document.addEventListener("DOMContentLoaded", function () {
    const filterAlphabet = document.querySelectorAll('.filter-select--alphabet')
    filterAlphabet.forEach(filter => {
        const letters = filter.querySelectorAll('.filter-select__list li input')
        letters.forEach(letter => {
            letter.addEventListener('change', (event) => {
                // Uncheck all checkboxes except the one that was clicked
                letters.forEach(el => {
                    if (el !== event.target) {
                        el.checked = false;
                    }
                })
            })
        })
    })
})
